var swal = require('sweetalert2');
var AjaxController = require('../../services/AjaxController');

/**
 * Helper
 */
var helper = require('../../helper'),
    dataTables_buttons = [

        {
            extend: 'csv',
            text: 'Export as CSV',
            exportOptions: {
                columns: '.csv-export'
            },
            className: 'btn btn-default'
        },
        {
            extend: 'pdf',
            text: 'Export as PDF',
            exportOptions: {
                columns: '.pdf-export'
            },
            className: 'btn btn-default'
        },
        {
            extend: 'colvis',
            className: 'btn btn-default'
            //     columns: ':gt(0)'
        }


    ],
    dataTables_columns_export = [
        {data: 'clientContactName', name:'clientContactName', title: 'Company contact', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'price_from', name:'price_from', title: 'Price from', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'price_to', name:'price_to', title: 'Price to', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'actual_market_rent', name:'actual_market_rent', title: 'Actual market rent', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'spaces', name:'spaces', title: 'Spaces', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'bathrooms', name:'bathrooms', title: 'Bathrooms', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'kitchens', name:'kitchens', title: 'Kitchens', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'garden', name:'garden', title: 'Gardens', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'parking', name:'parking', title: 'Parking', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'vip_amount', name:'vip_amount', title: 'VIP amount', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'vip_provided', name:'vip_provided', title: 'VIP provided', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'savings_made', name:'savings_made', title: 'Savings made', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'date_taken_on', name:'date_taken_on', title: 'Date taken on', orderable: true, searchable: true, visible: false, className: 'csv-export'},
        {data: 'date_live', name:'date_live', title: 'Date live', type: "date-uk", orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'date_taken_back', name:'date_taken_back', title: 'Date taken back', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'date_feature_from', name:'date_feature_from', title: 'Date feature from', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'date_feature_to', name:'date_feature_to', title: 'Date feature to', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'short_description', name:'short_description', title: 'Description', orderable: false, searchable: true, visible: false, className: 'pdf-export csv-export'},
        {data: 'property_note', name:'property_note', title: 'Property Note', orderable: false, searchable: true, visible: false, className: 'pdf-export csv-export'},
        {data: 'fit_out_note', name:'fit_out_note', title: 'Fit Out Note', orderable: false, searchable: true, visible: false, className: 'pdf-export csv-export'},
        {data: 'utility_note', name:'utility_note', title: 'Utility Note', orderable: false, searchable: true, visible: false, className: 'pdf-export csv-export'},
        {data: 'public_short_description', name:'public_short_description', title: 'Public short dsc', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'address', name:'address', title: 'Address', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'town', name:'town', title: 'Town', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'geo_latitude', name:'geo_latitude', title: 'Latitude', orderable: true, searchable: true, visible: false, className: 'csv-export'},
        {data: 'geo_longitude', name:'geo_longitude', title: 'Longitude', orderable: true, searchable: true, visible: false, className: 'csv-export'},
        {data: 'video', name:'video', title: 'Video', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: '3d_mapping', name:'3d_mapping', title: '3D Mapping', orderable: false, searchable: true, visible: false, className: 'csv-export'},
        {data: 'client_type', name:'client_type', title: 'Client type', orderable: false, searchable: true, visible: false},
        {data: 'days_is_status', name:'days_is_status', title: 'Days in status', orderable: false, searchable: false, visible: false},
        {data: 'accountManager', name:'accountManager', title: 'Account Manager', orderable: true, searchable: true, visible: false},
        
    ];


$(function() {
    var $datatable = $('#datatable-all-properties'),
        $dt;

    $dt = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "buttons": dataTables_buttons,
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "ajax": {
            "url": helper.getOrigin() + "/api/properties",
            "method": 'POST',
            "data": function ( d ) {
                d.status_id = (localStorage.getItem('DataTables_all_properties_status_id')) ? localStorage.getItem('DataTables_all_properties_status_id') : $('input[name="clickedStatusId"]').val();
            }
        },
        "stateSave": true,
        "stateSaveCallback": function(settings,data) {
            localStorage.setItem( 'DataTables_all_properties_state_' + settings.sInstance, JSON.stringify(data) );
            localStorage.setItem('DataTables_all_properties_status_id', $('input[name="clickedStatusId"]').val() );
        },
        "stateLoadCallback": function(settings) {
            return JSON.parse( localStorage.getItem( 'DataTables_all_properties_state_' + settings.sInstance ) )
        },
        "autoWidth" : false,
        "order": [[ 0, "asc" ]],
        "columnDefs": [
            { "type": "date-uk", targets: 18 }, // not work
        ],
        "columns": [
            {data: 'propertyName', name: 'propertyName', className: 'pdf-export csv-export'},
            {data: 'property_id', name: 'property_id', className: 'pdf-export csv-export'},
            {data: 'clientName', name: 'clientName', className: 'pdf-export csv-export'},
            {data: 'postcode', name: 'postcode', className: 'pdf-export csv-export'},
            {data: 'status', name: 'status', orderable: false, searchable: false, className: 'csv-export'},
            {data: 'date_notice', name:'date_notice', title: 'Notice date', type: "date-uk", orderable: false, searchable: true, className: 'csv-export'},
            {data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action"}
        ].concat(dataTables_columns_export),
        'columnDefs': [

            {
            'targets': 24,
            'className': 'dt-body-center tiny-column',
            'render': function (data, type, full, meta){
                if (data[2] !== null && data[3] !== null) {
                    return '<textarea id="short-description-'+data[0]+'" rows="5" cols="75" type="text" name="short-description[]" class="js-properties-update-field" data-property="'+data[0]+'" data-field="short_description">'+data[1]+'</textarea>' +
                        '<span class="pull-left" style="font-size: smaller;"><i>Last edited by '+ data[2] +' at '+ data[3] +'</i></span>';
                } else {
                    return '<textarea id="short-description-'+data[0]+'" rows="5" cols="75" type="text" name="short-description[]" class="js-properties-update-field" data-property="'+data[0]+'" data-field="short_description">'+data[1]+'</textarea>' +
                        '<span class="pull-left" style="font-size: smaller;"><i>Last edited by</i></span>';;
                }
            },
            },
            {
                'targets': 25,
                'className': 'dt-body-center tiny-column',
                'render': function (data, type, full, meta){
                    
                        return '<textarea id="short-description-'+data[0]+'" rows="5" cols="75" type="text" name="short-description[]" class="js-properties-update-field" data-property="'+data[0]+'" data-field="short_description">'+data[1]+'</textarea>';
                              
                    }
                
            },
            {
                'targets': 26,
                'className': 'dt-body-center tiny-column',
                'render': function (data, type, full, meta){
                    
                        return '<textarea id="short-description-'+data[0]+'" rows="5" cols="75" type="text" name="short-description[]" class="js-properties-update-field" data-property="'+data[0]+'" data-field="short_description">'+data[1]+'</textarea>';
                              
                    }
                
            },
            {
                'targets': 27,
                'className': 'dt-body-center tiny-column',
                'render': function (data, type, full, meta){
                    
                        return '<textarea id="short-description-'+data[0]+'" rows="5" cols="75" type="text" name="short-description[]" class="js-properties-update-field" data-property="'+data[0]+'" data-field="short_description">'+data[1]+'</textarea>';
                              
                    }
                
            }
        ],
        "initComplete": function(settings, json) {
            // init callback
        }
    });


    $('.js-property-activity-box').on('click', function() {
        var $this = $(this),
            $clickedStatusId = $('input[name="clickedStatusId"]'),
            statusId = $(this).data('status_id');

        $clickedStatusId.val(statusId);

        var valueToDisplay = $(this).children('.activity-title').data('to_display');
        $('#property-status-span').text( 'Properties of ' + valueToDisplay + ' status' );

        localStorage.setItem( 'DataTables_all_properties_state_' + $dt.settings.sInstance, JSON.stringify( $dt.data ) );
        localStorage.setItem( 'DataTables_all_properties_status_id', $('input[name="clickedStatusId"]').val() );

        $dt.ajax.reload();
    });

    $dt.on('click', 'td', function () {
        var old = $(this).html();
        var cell = $dt.cell(this);

        $(document).on('change', '.js-properties-update-field', function(e){

            var $this = $(this);
            var propertyId = $this.data('property'),
                field = $this.data('field'),
                value = $this.val();
            var url = '/api/properties/update-field';

            var data = {
                field: field,
                propertyId: propertyId,
                value: value
            };
            var success = function (response) {
                console.log('Success');
            }
            var error = function (response) {
                console.log('Error');
            }

            e.preventDefault();

            swal({
                title: "Are you sure you want to save changes?",
                text: "",
                type: "warning",
                showCancelButton: true
            }).
            then(function (result) {
                if (result.value) {
                    AjaxController.prototype.send(url, data, success, error);
                    // cell.data(data).draw();
                } else {
                    cell.data(old).draw();
                }
            })
        });
    });
});
